var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompletedActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "completed-active_svg__a",
    x1: "95.577%",
    x2: "0%",
    y1: "26.498%",
    y2: "75.783%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#B1B1B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E1E1E1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#202E4A"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#completed-active_svg__a)",
    strokeWidth: 2,
    d: "M20.297 20.228H1.925a1.442 1.442 0 01-1.442-1.441V6.406c0-.796.646-1.442 1.442-1.442h18.372c.796 0 1.442.646 1.442 1.442v12.38c0 .797-.646 1.442-1.442 1.442z",
    transform: "translate(4.611 1.444)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeWidth: 2.083,
    d: "M19.849 6.409h-8.367V3.222c0-.8.65-1.45 1.45-1.45H18.4c.8 0 1.45.65 1.45 1.45v3.187zM19.333 11.333l-5.112 5.216a.3.3 0 01-.43 0L12 14.724"
  }))));
}
export default SvgCompletedActive;